import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class Point extends AdornisEntity {
  public static override _class = 'Point';

  constructor(doc: PartialEntityData<Point>) {
    super(doc);
  }

  @Field(type => Float, { default: v => v ?? -1 })
  public x!: number;

  @Field(type => Float, { default: v => v ?? -1 })
  public y!: number;
}
